import React, { useState } from "react";
import logo from "../assets/images/logo.png";
import "../assets/css/Navbar.css";
import { Link } from "react-router-dom";

function Navbar() {
  const [menu, setmenu] = useState(false);
  const mobileMenu = () => {
    if (menu === true) {
      setmenu(false);
    } else {
      setmenu(true);
    }
  };
  return (
    <header className="text-gray-600 body-font border-b-2 border-F2F4F7">
      <div className="container mx-auto flex flex-wrap p-5 flex-row items-center justify-between">
        <Link
          to="/"
          className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0 mb-auto my-auto"
        >
          <img src={logo} className="w-36" alt="logo" />
        </Link>
        <nav className="md:ml-auto md:flex flex-wrap font-medium hidden items-center text-base justify-center">
          <Link to="/contact" className="mr-8 text-667085 hover:text-gray-900">
            Contact us
          </Link>
        </nav>
        <Link to="/" state={{ eventsId: "events" }}>
          <button
            //   onClick={() => window.location.replace("/#events")}
            className="md:inline-flex hidden items-center bg-088AB2 border-0 py-2 px-4 focus:outline-none hover:bg-gray-200 rounded-8 text-white mt-4 md:mt-0"
          >
            Register Now
          </button>
        </Link>

        <button
          type="button"
          onClick={mobileMenu}
          class="inline-flex items-center cursor-pointer ml-3 text-md justify-end text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          aria-controls="mobile-menu"
        >
          <span class="sr-only">Open main menu</span>
          <svg
            class={`w-6 h-6 ${menu === true ? "hidden" : ""}`}
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <svg
            class={`w-6 h-6 ${menu === false ? "hidden" : ""}`}
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>
      </div>
      <div
        className={`container mx-auto flex flex-wrap p-5 ${
          menu === false ? "hidden" : ""
        } flex-row items-top justify-center`}
      >
        <button
          onClick={() => window.location.replace("/contact")}
          className="md:inline-flex items-center bg-088AB2 border-0 py-2 px-4 focus:outline-none hover:bg-gray-200 rounded-8 text-white mt-4 md:mt-0"
        >
          Contact Us
        </button>
        &ensp;
        <button
          onClick={() => window.location.replace("/#events")}
          className="md:inline-flex items-center bg-088AB2 border-0 py-2 px-4 focus:outline-none hover:bg-gray-200 rounded-8 text-white mt-4 md:mt-0"
        >
          Register Now
        </button>
      </div>
    </header>
  );
}

export default Navbar;
